export const handleSentinelInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: string,
  inputBoolean: boolean,
  objectId: number | null,
  inputNameString: string
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const sentinelAlertPostObject = JSON.parse(
    localStorage.sentinelAlertPostObject || "{}"
  );

  if (inputNameString === "drawIgnoreZones") {
    sentinelAlertPostObject.draw_ignore_zones = inputBoolean;
  }
  if (inputNameString === "sentinelServer") {
    sentinelAlertPostObject.sentinel_server = inputString;
  }
  if (inputNameString === "sentinelSiteId") {
    sentinelAlertPostObject.sentinel_site_id = inputString;
  }
  if (inputNameString === "sentinelDeviceAddress") {
    sentinelAlertPostObject.sentinel_device_address = inputString;
  }

  localStorage.setItem(
    "sentinelAlertPostObject",
    JSON.stringify(sentinelAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      sentinel: {
        ...camerasObject[key].sentinel,
      },
    };
  }

  if (objectId) {
    // Handle single object update
    if (inputNameString === "drawIgnoreZones") {
      newCamerasObject[objectId].sentinel.draw_ignore_zones = inputBoolean;
    }
    if (inputNameString === "sentinelServer") {
      newCamerasObject[objectId].sentinel.sentinel_server = inputString;
    }
    if (inputNameString === "sentinelSiteId") {
      newCamerasObject[objectId].sentinel.sentinel_site_id = inputString;
    }
    if (inputNameString === "sentinelDeviceAddress") {
      newCamerasObject[objectId].sentinel.sentinel_device_address = inputString;
    }

    setCamerasObject((previousState: any) => {
      return { ...previousState, [objectId]: newCamerasObject[objectId] };
    });
  } else {
    // Handle all objects update
    if (inputNameString === "drawIgnoreZones") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].sentinel.draw_ignore_zones = inputBoolean;
      }
    }
    if (inputNameString === "sentinelServer") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].sentinel.sentinel_server = inputString;
      }
    }
    if (inputNameString === "sentinelSiteId") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].sentinel.sentinel_site_id = inputString;
      }
    }
    if (inputNameString === "sentinelDeviceAddress") {
      for (const key in newCamerasObject) {
        newCamerasObject[key].sentinel.sentinel_device_address = inputString;
      }
    }

    setCamerasObject(newCamerasObject);
  }
};
